import { render, staticRenderFns } from "./FormLegend.vue?vue&type=template&id=2ef36608"
import script from "./FormLegend.vue?vue&type=script&lang=ts"
export * from "./FormLegend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports